import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { profile } from "../data/resume";

// Social URLs come from src/data/resume.js so the footer and the home page can
// never disagree again - they used to hold two different LinkedIn handles and
// two different Twitter handles, one of each being a dead link.
const socials = [
  { href: profile.github, label: "GitHub", Icon: AiFillGithub },
  { href: profile.twitter, label: "Twitter", Icon: AiOutlineTwitter },
  { href: profile.linkedin, label: "LinkedIn", Icon: FaLinkedinIn },
  { href: profile.instagram, label: "Instagram", Icon: AiFillInstagram },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by {profile.name}</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} AR</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            {socials.map(({ href, label, Icon }) => (
              <li className="social-icons" key={label}>
                <a
                  href={href}
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                >
                  <Icon />
                </a>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
